<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import api from '@/api';
import PersonalNewsCountdown from '@/components/common/personal_news/personal-news-countdown.vue';
import ArticlesWeek from '@/components/personal-news/articles-week.vue';
import PersonalNewsPageLayout from '@/components/personal-news/personal-news-page-layout.vue';
import {
  PERSONAL_NEWS_AFTERNOON_UPDATE_HOUR,
  PERSONAL_NEWS_MORNING_UPDATE_HOUR,
} from '@/utils/personalNews';
import { useUserInfo, useUserPersonalNewsDocumentCounts } from '@/utils/swr';
import { useEmitter } from '@/utils/vue';

const route = useRoute();
const emitter = useEmitter();
const { data: userInfo } = useUserInfo();
const { mutate: mutateFeedCount } = useUserPersonalNewsDocumentCounts();

const updateFeedCount = () => mutateFeedCount();

const hasPersonalNews = computed(
  () => userInfo.value?.has_personal_news ?? false,
);

onMounted(() => {
  api.trackPageView({
    pageName: 'personal_news',
    pageUrl: route.fullPath,
  });
  emitter.on('personal-feed-article-removed', updateFeedCount);
  emitter.on('personal-feed-article-restored', updateFeedCount);
});

onUnmounted(() => {
  emitter.off('personal-feed-article-removed', updateFeedCount);
  emitter.off('personal-feed-article-restored', updateFeedCount);
});
</script>

<template>
  <PersonalNewsPageLayout>
    <div class="feed-content" v-if="userInfo">
      <div class="articles" v-if="hasPersonalNews">
        <div class="title">
          <span class="subtitle c-text-regular--m">
            ニュースは毎日{{ PERSONAL_NEWS_MORNING_UPDATE_HOUR }}:00と{{
              PERSONAL_NEWS_AFTERNOON_UPDATE_HOUR
            }}:00の2回更新されます。
          </span>
        </div>
        <ArticlesWeek />
      </div>
      <div class="no-articles" v-else>
        <PersonalNewsCountdown
          :actioned-article-counts="
            userInfo.personal_news_counts ?? { domestic: 0, foreign: 0 }
          "
        />
      </div>
    </div>
  </PersonalNewsPageLayout>
</template>

<style lang="scss" scoped>
.feed-content {
  display: flex;
  flex-direction: column;

  .title {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 16px;

    .subtitle {
      color: $color-gray600;
    }
  }
}
</style>
